import { EMAIL_SENDS } from '../constants/LimitIds';
import { isQuantityPackDetails } from './typeguards';
export const getEmailSendsLimitMultiplier = (state, {
  quantityPackSkuId
}) => {
  const {
    productData: {
      skuMap
    }
  } = state;
  const sku = skuMap[quantityPackSkuId];
  if (!isQuantityPackDetails(sku)) return 0;
  const {
    includedWithQuantityPack,
    packagedQuantities
  } = sku;
  const emailSendLimit = packagedQuantities.find(limit => limit.name === EMAIL_SENDS);
  if (!emailSendLimit || !includedWithQuantityPack) return 0;
  return emailSendLimit.quantity / includedWithQuantityPack;
};

/**
 * @description
 * If using the result of this function in % (modulo) operation, handle `Infinity`.
 * `Infinity % x` will result in `NaN`.
 */
export const getMaxAdditionalUnits = quantityPack => {
  var _quantityPack$include;
  const maxTouchlessPurchasableQuantity = typeof quantityPack.maxTouchlessPurchasableQuantity !== 'number' ? Infinity : quantityPack.maxTouchlessPurchasableQuantity;
  const includedWithQuantityPack = (_quantityPack$include = quantityPack.includedWithQuantityPack) !== null && _quantityPack$include !== void 0 ? _quantityPack$include : 0;
  return includedWithQuantityPack * maxTouchlessPurchasableQuantity;
};
const createSteppingFunction = (min, max, step) => (input, roundUp = false) => {
  return Math.min(Math[roundUp ? 'ceil' : 'round']((Math.max(input, min) - min) / step) * step + min, max === Infinity ? Infinity : max - (max - min) % step);
};
export const getQuantityPackSteppingFunction = quantityPack => {
  const maxAdditionalUnits = getMaxAdditionalUnits(quantityPack);
  const {
    includedWithQuantityPack
  } = quantityPack;
  return createSteppingFunction(0, maxAdditionalUnits === Infinity ? Infinity : maxAdditionalUnits - maxAdditionalUnits % ( // avoid division by zero
  includedWithQuantityPack !== null && includedWithQuantityPack !== void 0 ? includedWithQuantityPack : 1), includedWithQuantityPack !== null && includedWithQuantityPack !== void 0 ? includedWithQuantityPack : 0);
};